import { Link } from "react-router-dom";
import { ArrowRight, PenNib, Ruler, SealCheck, Signature } from "@phosphor-icons/react";

const ICON = { accept: SealCheck, sign: Signature, drawing: Ruler };

// Home-screen call to action: every quote that still needs the customer's approval,
// signature or drawing sign-off — loud on purpose, nothing should sit unnoticed here.
export const PortalApprovalsCard = ({ quotes = [] }) => {
  const pending = quotes.filter((q) => (q.pending_actions || []).length > 0);
  if (!pending.length) return null;
  const total = pending.reduce((n, q) => n + q.pending_actions.length, 0);

  return (
    <section
      data-testid="portal-approvals-card"
      className="relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6"
    >
      <span className="pointer-events-none absolute inset-y-0 left-0 w-1 bg-amber-500" />
      <div className="flex flex-wrap items-center gap-3">
        <span className="relative flex h-3 w-3">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-500 opacity-70" />
          <span className="relative inline-flex h-3 w-3 rounded-full bg-amber-600" />
        </span>
        <h2 className="text-base font-bold text-slate-900 md:text-lg">
          Needs your approval
        </h2>
        <span
          data-testid="portal-approvals-count"
          className="rounded-full bg-amber-600 px-2.5 py-0.5 text-[11px] font-bold text-white"
        >
          {total}
        </span>
      </div>
      <p className="mt-1 text-sm text-slate-600">
        We can’t start until these are done — it only takes a minute each.
      </p>
      <div className="mt-4 space-y-3">
        {pending.map((q) => {
          const first = q.pending_actions[0];
          return (
            <div
              key={q.id}
              data-testid={`portal-approval-${q.id}`}
              className="flex flex-col gap-3 rounded-xl border border-slate-200/80 bg-slate-50 p-4 sm:flex-row sm:items-center"
            >
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-mono-data text-xs text-slate-400">{q.code}</span>
                  <span className="truncate text-sm font-semibold text-slate-900">
                    {q.project_name || "Your quote"}
                  </span>
                </div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {q.pending_actions.map((a) => {
                    const Icon = ICON[a.key] || PenNib;
                    return (
                      <span
                        key={a.key}
                        data-testid={`portal-approval-${q.id}-${a.key}`}
                        className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-amber-800 ring-1 ring-amber-200"
                      >
                        <Icon size={12} weight="bold" /> {a.label}
                      </span>
                    );
                  })}
                </div>
              </div>
              <Link
                to={`/portal/quotes/${q.id}?action=${first.key}`}
                data-testid={`portal-approval-go-${q.id}`}
                className="inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl bg-amber-600 px-5 text-[11px] font-bold uppercase tracking-widest text-white shadow-sm transition-colors hover:bg-amber-700"
              >
                Review &amp; {first.label.toLowerCase()} <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};
